import type { CommunityDetail } from '@pba/react-network';
import { ContentWrapper, withErrorBoundary } from 'ui';
import { CommunitySideCards } from '../community-side-cards';
import { CommunityFeedContent } from './community-feed-content';

export type P = {
  community: CommunityDetail;
};

const CommunityFeed = ({ community }: P) => (
  <ContentWrapper aside={<CommunitySideCards community={community} />}>
    {/* TODO: Will be used in Task #87927 for Community feed administrators card */}
    <CommunityFeedContent community={community} />
  </ContentWrapper>
);

export default withErrorBoundary(CommunityFeed);
